
const APPY_DEALS_TAG_TYPE = 'FixedPricePromo';
const APPY_DEALS_BADGE_IMG_NAME = 'appy-deals';
const APPY_DEALS_PAGE_NAME = 'appy-deals';
const APPY_DEALS_PAGE_SOURCE_ID = 'ProductGroup.489543';
const APPY_DEALS_EVENT_DATA = 'AppyDealsEventData';

function isAppyDealsBadge(fileName = '') {
    return (typeof fileName === 'string' && fileName.indexOf(APPY_DEALS_BADGE_IMG_NAME) >= 0);
}

/**
 * appyDealsCheck
 * @description check if a product is Appy Deals promotion
 * The product API may remove 'IsAppBasedOffer'.
 * Therefore do some duck typing check instead if not present.
 * @param {object} product data
 * @returns {boolean}
 */
function appyDealsCheck(product) {
    let ret = false;

    if (!product) {
        return ret;
    }

    if (product.IsAppBasedOffer) {
        return true;
    }

    if (product.FixedPricePromoTag && product.FixedPricePromoTag.TagType === APPY_DEALS_TAG_TYPE) {
        if (Array.isArray(product.Tags)) {
            const tagLength = product.Tags.length;

            for (let i = 0; i < tagLength; i += 1) {
                const tagName = product.Tags[i];

                if (isAppyDealsBadge(tagName)) {
                    ret = true;
                    break;
                }
            }
        }
    }

    return ret;
}

module.exports = {
    appyDealsCheck,
    isAppyDealsBadge,
    APPY_DEALS_PAGE_NAME,
    APPY_DEALS_PAGE_SOURCE_ID,
    APPY_DEALS_EVENT_DATA
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/common/utility/appyDealsCheck.js
 **/